import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ trail }) => (
  <nav aria-label="Breadcrumb" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
    <ol className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500">
      {trail.map(([name, path], i) => (
        <li key={path} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={13} className="text-slate-300" />}
          {i < trail.length - 1 ? (
            <Link to={path} className="hover:text-emerald-700 transition-colors">{name}</Link>
          ) : (
            <span aria-current="page" className="font-semibold text-slate-800">{name}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
